import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class ApplicationResource {
  private baseUri = '/prl/applications';

  constructor(private ApiService: ApiService) {}

  // GET
  fetchApplicationForPatient(params: {
    patientId: Docorga.interfaces.naturalTypes.NPatientObjectId;
    professionalId: string;
  }): Observable<Docorga.interfaces.application.IApplicationJson | undefined> {
    return this.ApiService.get(`${this.baseUri}/patientApplication`, params);
  }

  findApplicationsByFolder(params: {
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
  }): Observable<Array<Docorga.interfaces.application.IApplicationJson>> {
    return this.ApiService.get(`${this.baseUri}/byFolder`, params);
  }

  // POST
  createApplication(params: {
    praticienId: string;
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
  }): Observable<Docorga.interfaces.application.IApplicationJson | string | void> {
    return this.ApiService.post(`${this.baseUri}`, params);
  }

  // PUT
  updateApplicationStatus(params: {
    applicationId: Docorga.interfaces.naturalTypes.NApplicationObjectId;
    status: Docorga.interfaces.application.IApplicationJson['status'];
    message?: string;
  }): Observable<void> {
    return this.ApiService.put(`${this.baseUri}/${params.applicationId}/updateApplicationStatus`, params);
  }
}
